/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useAlert } from 'components/provider/Alert';
import { useAuth } from 'components/provider/Auth';
import { useCallback, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/shared/Button';
import Input from 'components/shared/ControlledInput';

const LoginForm = ({
  onSubmit = () => {}
}) => {
  const { login } = useAuth();
  const { alertFailure } = useAlert();
  const [ email, setEmail ] = useState('');
  const [ password, setPassword ] = useState('');
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const submit = useCallback(() => {
    if (!email) {
      alertFailure('You must provide an email address.');
      return;
    }
    
    if (!password) {
      alertFailure('You must provide a password.');
      return;
    }

    login({ email, password });

    onSubmit();
  },[
    alertFailure,
    email,
    password,
    login,
    onSubmit,
  ])

  return (
    <div 
      css={{ 
        display: 'flex',
        flexDirection: 'column',
        marginTop: 40,
        marginBottom: 10,
        gap: 10
      }}
    >
      <div>
        <label htmlFor="email">Email</label>
        <Input 
          ref={emailRef} 
          name="email" 
          value={email} 
          onPressEnter={submit} 
          onChange={setEmail} 
          style={{ height: 32 }}
        />
      </div>

      <div>
        <label htmlFor="password">Password</label>
        <Input 
          ref={passwordRef} 
          name="password" 
          value={password} 
          onPressEnter={submit} 
          onChange={setPassword} 
          type="password" 
          style={{ height: 32 }}
        />
      </div>

      <div css={{ 
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: 10
      }}>
        <Button type="primary" onClick={submit}>
          Submit
        </Button>
        <Link to="/password_reset">Forgot your password?</Link>
      </div>
    </div>
  )
}

export default LoginForm;